import { render, staticRenderFns } from "./BuySection.vue?vue&type=template&id=ae9c3a44&"
import script from "./BuySection.vue?vue&type=script&lang=js&"
export * from "./BuySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports